// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/Text","truncate":"Text-m__truncate__yeE5c","uppercase":"Text-m__uppercase__11_H5"};